module.exports = __webpack_public_path__ + "img/logo-p-sfdda.cff24e0e.jpg";